export default __webpack_public_path__ + "static/media/A4_22.df8d8cfd.mp3";